import React from 'react';
import { ContactDetail } from '../../../src/types/ContactDetail';

interface ContactInfoProps { contactData: ContactDetail[]; titleColorClass?: string }

const ContactInfo: React.FC<ContactInfoProps> = ({ contactData, titleColorClass = 'text-gray-900' }) => {
  return (
    <div className="container mx-auto px-6 py-12">
      <h2 className={`text-4xl font-extrabold ${titleColorClass} text-center mb-10`}>Get In Touch</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {contactData.map((item, index) => {
            const coloredIcon = React.cloneElement(item.icon, { className: `${item.icon.props.className} ${item.iconColorClass}` });
            return (
              <a key={index} href={item.link || '#'} target={item.link ? '_blank' : '_self'} rel={item.link ? 'noopener noreferrer' : undefined} className={`flex flex-col items-start p-6 rounded-xl shadow-lg transition-all duration-300 transform ${item.link ? 'bg-white shadow-xl hover:shadow-2xl hover:-translate-y-1 border border-gray-100' : 'bg-white shadow-lg'}`} onClick={!item.link ? (e) => e.preventDefault() : undefined}>
                <div className="flex-shrink-0 mb-4 p-3 bg-gray-100 rounded-full">{coloredIcon}</div>
                <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">{item.label}</p>
                <p className={`text-xl font-bold ${item.link ? 'text-gray-900 hover:text-blue-600' : 'text-gray-900'}`}>{item.value}</p>
              </a>
            );
        })}
      </div>
    </div>
  );
};

export default ContactInfo;
